<div id="earn-tab-create" class="tw-w-full tw-py-4">
  <!-- ensure the wrapper doesn't clip the dropdown -->
  <div class="table-wrapper tw-w-full tw-overflow-visible">
    <div class="tw-mb-2 tw-flex tw-justify-between tw-items-center">
      <div class="tw-flex tw-w-full tw-justify-between tw-items-center">
        <!-- breadcrumb states (progress-style, non-clickable) -->
        <nav class="tw-flex tw-items-center tw-gap-3" aria-label="Progress">
          @for (state of draftTable.states; let i = $index; track state) {
            <!-- each crumb -->
            <span
              class="tw-text-sm tw-font-medium tw-leading-6"
              [ngClass]="{
                'tw-text-dt-custom-teal-9 tw-underline tw-underline-offset-2 tw-decoration-2':
                  state === this.earnService.breadCrumbState(),

                'tw-text-dt-text-disabled tw-opacity-60':
                  i < draftTable.states.indexOf(this.earnService.breadCrumbState()),

                'tw-text-dt-text-headings':
                  i > draftTable.states.indexOf(this.earnService.breadCrumbState()),
              }"
            >
              {{ draftTable.stateLabels[state] }}
            </span>

            @if (i < draftTable.states.length - 1) {
              <svg class="tw-h-4 tw-w-4 tw-text-dt-text-disabled" aria-hidden="true">
                <use [attr.xlink:href]="'images/sprite.svg#' + 'right-arrow'"></use>
              </svg>
            }
          }
        </nav>
        @if (this.earnService.breadCrumbState() === "publish") {
          <span>{{ earnService.selectedMaskVersion() }}</span>
        }
      </div>

      @if (this.earnService.breadCrumbState() === "draft") {
        <!-- top-right buttons (make this a stacking context and allow overflow) -->
        <div
          class="tw-flex tw-items-center tw-space-x-2 tw-relative tw-overflow-visible tw-z-[200]"
        >
          <app-gloss-button
            [options]="{
              text: 'addLatestTransaction' | i18n,
              isEnabled: true,
              onClick: addLatestTransaction.bind(this),
              fullClass: 'btn-squared',
              icon: 'add',
            }"
          ></app-gloss-button>

          <!-- Visibility Management button + dropdown -->
          <div class="tw-relative" id="visibility-management">
            <app-gloss-button
              [options]="{
                text: 'visibilityManagement' | i18n,
                isEnabled: true,
                onClick: toggleVisibilityMenu.bind(this),
                fullClass: 'btn-squared',
                icon: 'down-arrow',
              }"
              id="visibility-management-button"
            ></app-gloss-button>

            @if (showVisibilityMenu()) {
              <div
                class="tw-absolute tw-top-full tw-right-0 tw-mt-2 tw-w-[320px] tw-z-[2000]"
                role="menu"
                aria-labelledby="visibility-management-button"
                (click)="$event.stopPropagation()"
              >
                <!-- forced 2px border and higher priority -->
                <div
                  class="tw-bg-dt-surface-elevated tw-rounded-lg tw-shadow-xl !tw-border-2 !tw-border-solid !tw-border-dt-border-primary tw-overflow-hidden tw-select-none"
                >
                  <!-- Reset to last published -->
                  <button
                    type="button"
                    class="tw-w-full tw-text-left tw-text-dt-text-headings tw-font-medium tw-text-sm tw-px-4 tw-py-3 hover:tw-bg-dt-surface-elevated focus-visible:-tw-outline-offset-2"
                    (click)="onResetToLastPublished()"
                  >
                    Reset to last published
                  </button>
                  <div class="tw-h-px tw-bg-dt-neutral-200"></div>

                  <!-- REDACT -->
                  <div class="tw-flex tw-items-center tw-justify-between tw-px-4 tw-pt-3 tw-pb-1">
                    <div class="tw-flex tw-items-center tw-gap-2">
                      <svg
                        class="tw-w-4 tw-h-4 tw-text-dt-text-tertiary"
                        viewBox="0 0 24 24"
                        fill="none"
                        aria-hidden="true"
                      >
                        <path
                          d="M3 3l18 18M21 12c-2.5 4-6 6-9 6-3 0-6.5-2-9-6 1.1-1.8 2.5-3.2 4-4.2"
                          stroke="currentColor"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                        <path
                          d="M9.9 9.9A3 3 0 0012 15a3 3 0 002.1-.9"
                          stroke="currentColor"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                      </svg>
                      <span
                        class="tw-text-[11px] tw-tracking-wide tw-uppercase tw-text-dt-text-tertiary"
                        >Redact</span
                      >
                    </div>
                    <span class="tw-text-dt-text-disabled tw-text-xs" aria-hidden="true">i</span>
                  </div>

                  <div class="tw-px-1 tw-pb-2">
                    <button
                      class="tw-w-full tw-flex tw-items-center tw-gap-3 tw-rounded-md tw-px-3 tw-py-2 tw-text-sm tw-text-dt-text-disabled tw-cursor-not-allowed"
                      disabled
                    >
                      <span
                        class="tw-inline-flex tw-items-center tw-justify-center tw-w-4 tw-h-4 tw-rounded tw-border tw-border-dt-border-primary"
                      ></span>
                      <span>Redact cells</span>
                    </button>

                    <button
                      class="tw-w-full tw-flex tw-items-center tw-gap-3 tw-rounded-md tw-px-3 tw-py-2 tw-text-sm tw-bg-dt-surface-sunken tw-text-dt-text-headings hover:tw-bg-dt-neutral-200"
                      (click)="onRedactColumns()"
                    >
                      <span class="tw-inline-grid tw-grid-cols-3 tw-gap-[2px] tw-w-4 tw-h-4">
                        <span class="tw-bg-neutral-700 tw-rounded-[2px]"></span>
                        <span class="tw-bg-neutral-300 tw-rounded-[2px]"></span>
                        <span class="tw-bg-neutral-300 tw-rounded-[2px]"></span>
                      </span>
                      <span>Redact columns</span>
                    </button>

                    <button
                      class="tw-w-full tw-flex tw-items-center tw-gap-3 tw-rounded-md tw-px-3 tw-py-2 tw-text-sm tw-text-dt-text-disabled tw-cursor-not-allowed"
                      disabled
                    >
                      <span class="tw-flex tw-flex-col tw-gap-[2px] tw-w-4 tw-h-4">
                        <span class="tw-bg-neutral-300 tw-h-[4px] tw-rounded-[2px]"></span>
                        <span class="tw-bg-neutral-300 tw-h-[4px] tw-rounded-[2px]"></span>
                        <span class="tw-bg-neutral-300 tw-h-[4px] tw-rounded-[2px]"></span>
                      </span>
                      <span>Redact rows</span>
                    </button>
                  </div>

                  <div class="tw-h-px tw-bg-dt-neutral-200"></div>

                  <!-- UNREDACT -->
                  <div class="tw-flex tw-items-center tw-justify-between tw-px-4 tw-pt-3 tw-pb-1">
                    <div class="tw-flex tw-items-center tw-gap-2">
                      <svg
                        class="tw-w-4 tw-h-4 tw-text-dt-text-tertiary"
                        viewBox="0 0 24 24"
                        fill="none"
                        aria-hidden="true"
                      >
                        <path
                          d="M2 12c2.5-4 6-6 10-6s7.5 2 10 6c-2.5 4-6 6-10 6s-7.5-2-10-6z"
                          stroke="currentColor"
                          stroke-width="1.5"
                        />
                        <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.5" />
                      </svg>
                      <span
                        class="tw-text-[11px] tw-tracking-wide tw-uppercase tw-text-dt-text-tertiary"
                        >Unredact</span
                      >
                    </div>
                    <span class="tw-text-dt-text-disabled tw-text-xs" aria-hidden="true">i</span>
                  </div>

                  <div class="tw-px-1 tw-pb-2">
                    <button
                      class="tw-w-full tw-flex tw-items-center tw-gap-3 tw-rounded-md tw-px-3 tw-py-2 tw-text-sm tw-text-dt-text-disabled tw-cursor-not-allowed"
                      disabled
                    >
                      <span class="tw-inline-grid tw-grid-cols-3 tw-gap-[2px] tw-w-4 tw-h-4">
                        <span class="tw-bg-neutral-300 tw-rounded-[2px]"></span>
                        <span class="tw-bg-neutral-300 tw-rounded-[2px]"></span>
                        <span class="tw-bg-neutral-300 tw-rounded-[2px]"></span>
                      </span>
                      <span>Unredact all</span>
                    </button>
                    <button
                      class="tw-w-full tw-flex tw-items-center tw-gap-3 tw-rounded-md tw-px-3 tw-py-2 tw-text-sm tw-text-dt-text-disabled tw-cursor-not-allowed"
                      disabled
                    >
                      <span
                        class="tw-inline-flex tw-items-center tw-justify-center tw-w-4 tw-h-4 tw-rounded tw-border tw-border-dt-border-primary"
                      ></span>
                      <span>Unredact cells</span>
                    </button>
                    <button
                      class="tw-w-full tw-flex tw-items-center tw-gap-3 tw-rounded-md tw-px-3 tw-py-2 tw-text-sm tw-text-dt-text-disabled tw-cursor-not-allowed"
                      disabled
                    >
                      <span class="tw-inline-grid tw-grid-cols-3 tw-gap-[2px] tw-w-4 tw-h-4">
                        <span class="tw-bg-neutral-300 tw-rounded-[2px]"></span>
                        <span class="tw-bg-neutral-300 tw-rounded-[2px]"></span>
                        <span class="tw-bg-neutral-300 tw-rounded-[2px]"></span>
                      </span>
                      <span>Unredact columns</span>
                    </button>
                    <button
                      class="tw-w-full tw-flex tw-items-center tw-gap-3 tw-rounded-md tw-px-3 tw-py-2 tw-text-sm tw-text-dt-text-disabled tw-cursor-not-allowed"
                      disabled
                    >
                      <span class="tw-flex tw-flex-col tw-gap-[2px] tw-w-4 tw-h-4">
                        <span class="tw-bg-neutral-300 tw-h-[4px] tw-rounded-[2px]"></span>
                        <span class="tw-bg-neutral-300 tw-h-[4px] tw-rounded-[2px]"></span>
                        <span class="tw-bg-neutral-300 tw-h-[4px] tw-rounded-[2px]"></span>
                      </span>
                      <span>Unredact rows</span>
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>

    @if (this.earnService.breadCrumbState() === "draft") {
      <app-ag-grid-table
        [options]="draftTable?.options"
        [data]="draftData()"
        [hasBottomBorder]="true"
        [hasTopBorder]="true"
        [hasHeader]="true"
      />
    } @else {
      <app-ag-grid-table
        [options]="viewTable?.options"
        [data]="previewData()"
        [hasBottomBorder]="true"
        [hasTopBorder]="true"
        [hasHeader]="true"
      />
    }
  </div>

  <div
    class="tw-flex tw-justify-between tw-items-center tw-mt-4 table-wrapper tw-w-full tw-bg-dt-surface-elevated tw-rounded tw-p-3"
  >
    <span>
      {{ rowsMasked() }} Hidden Row{{ rowsMasked() > 1 ? "s" : "" }} | {{ columnsMasked() }} Hidden
      Column{{ columnsMasked() > 1 ? "s" : "" }} | {{ cellsMasked() }} Hidden Cell{{
        cellsMasked() > 1 ? "s" : ""
      }}</span
    >

    <div class="tw-flex tw-gap-1">
      @if (earnService.breadCrumbState() === "draft") {
        <app-gloss-button
          class="tw-min-w-[200px] tw-mr-3"
          [options]="draftButtonOptions"
        ></app-gloss-button>
        <app-gloss-button
          class="tw-min-w-[200px]"
          [options]="previewButtonOptions"
        ></app-gloss-button>
      }

      @if (draftTable.earnService.breadCrumbState() === "preview") {
        <app-gloss-button
          class="tw-min-w-[200px]"
          [options]="publishButtonOptions"
        ></app-gloss-button>
      }

      @if (draftTable.earnService.breadCrumbState() === "publish") {
        <app-gloss-button
          class="tw-min-w-[200px]"
          [options]="editAsNewButtonOptions"
        ></app-gloss-button>
      }
    </div>
  </div>
</div>
